import styled from 'styled-components';

const Centered = styled.div`
  text-align: center;
`;

export default Centered;



// WEBPACK FOOTER //
// ./src/components/styledComponents/Centered.js